var exports = {
  "u": "StickersPicker.module__searchResultsContainer___czF6Nk",
};

module.exports = exports;
